const UNSAFE_TEXT_REGEX = /<\s*script|javascript:|onerror\s*=|onload\s*=|<\s*iframe|<\s*object|<\s*embed/i;

export const hasUnsafeText = (value = '') => {
  if (value === null || value === undefined) return false;
  return UNSAFE_TEXT_REGEX.test(String(value));
};

export const hasUnsafeTextInObject = (value) => {
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return hasUnsafeText(value);
  }

  if (Array.isArray(value)) {
    return value.some((entry) => hasUnsafeTextInObject(entry));
  }


  if (value && typeof value === 'object') {
    return Object.values(value).some((entry) => hasUnsafeTextInObject(entry));
  }

  return false;
};

export const isValidPhoneNumber = (value = '') => /^\d{10}$/.test(String(value).trim());

export const isValidPositiveNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0;
};

export const hasMaxLength = (value = '', max = 255) => String(value).trim().length <= max;

export const sanitizeText = (value = '') => String(value).trim();
